export const SHARED_PATH_PREFIXES = ['/shared/table/', '/shared/form/', '/shared/document/']

export const PUBLIC_STATIC_PATHS = [
  '/auth/login',
  '/auth/forgot-password',
  '/auth/sign-up',
  '/auth/confirmation',
  '/auth/set-password',
  '/auth/reset-password',
  '/oauth/callback',
]

/**
 * Check if a given pathname is a shared (public, unauthenticated) path.
 */
export const isSharedPath = (pathname: string): boolean =>
  SHARED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))

/**
 * Check if a given pathname is a public (unauthenticated) path.
 */
export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_STATIC_PATHS.includes(pathname) || isSharedPath(pathname)
